export const ITEM_HEIGHT = 48;
export const ITEM_PADDING_TOP = 8;

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const columnsConfig = [
  {
    id: "item_code",
    label: "Item Code",
    minWidth: 50,
    align: "center",
  },
  {
    id: "upc",
    label: "UPC",
    minWidth: 50,
    align: "center",
  },
  {
    id: "name",
    label: "Item Name",
    minWidth: 50,
    align: "left",
  },
  {
    id: "stock_level",
    label: "Stock",
    minWidth: 50,
    align: "center",
  },
];

export const initialStateSelectedItem = {
  id: 0,
  image: "",
  code: "",
  name: "",
  price: 0,
  count: 0,
  description: "",
  upc: "",
  location: "",
};